import clsx from 'clsx'
import compact from 'lodash/compact'
import map from 'lodash/map'
import React, { CSSProperties, useContext } from 'react'

import { Link } from '@Components/Link'
import { getMenuItemTitle } from '@Domains/Navigation/Features/Menu/helpers'
import { MetadataContext } from '@Globals/Metadata'

import styles from './Menu.module.scss'

export const TopMenu = ({
  className,
  ...props
}: React.ComponentProps<'nav'>) => {
  const { navigationTop } = useContext(MetadataContext)

  if (!navigationTop || navigationTop.length === 0) {
    return null
  }

  const items = compact(map(navigationTop, (menuItem) => {
    const page = menuItem.link?.references?.find(r => r.__typename === 'Page')
    if (!menuItem.link?.url
      || !page
      || !('id' in page)
      || !('type' in page)
    ) {
      return null
    }

    return (
      <li
        key={menuItem.id}
        style={{
          '--background-color-desktop': menuItem?.appearanceDesktop?.backgroundColor,
          '--text-color-desktop': menuItem?.appearanceDesktop?.textColor,
          '--background-color-mobile': menuItem?.appearanceMobile?.backgroundColor,
          '--text-color-mobile': menuItem?.appearanceMobile?.textColor,
        } as CSSProperties}
      >
        <Link
          analytics={{
            source_id: 'top_menu',
            dest_page_type: page.type,
            dest_page_type_id: page.id,
          }}
          className={clsx('anchor')}
          href={menuItem.link.url}
        >
          {getMenuItemTitle(menuItem)}
        </Link>
      </li>
    )
  }))

  if (items.length === 0) {
    return null
  }

  return (
    <nav className={clsx(styles.topmenu, className)} {...props}>
      <ul>
        {items}
      </ul>
    </nav>
  )
}
